import React from 'react';
import { ShopNowButton } from 'src/components/ShopNowButton/ShopNowButton';
import { SafeHtml } from 'src/components/SafeHtml/SafeHtml';
import { LazyImg } from 'src/hooks/useLazyLoad';

import classes from './HomeInfo.scss';

const BRAND_NAME = 'Workwear Express';

/**
 * Homepage title CSS colours a nested span. Magento sometimes omits that
 * markup (local) or HTML-encodes it (production). Normalise to a real span
 * with the module class so "Workwear Express" is always orange.
 */
export function withBrandHighlight(title: string | undefined, spanClass: string): string {
    if (!title) return '';
    const withoutSpans = title.replace(/&lt;\/?span(?:\s[^&]*)?&gt;/gi, '').replace(/<\/?span[^>]*>/gi, '');
    return withoutSpans.replace(new RegExp(BRAND_NAME, 'g'), `<span class="${spanClass}">${BRAND_NAME}</span>`);
}

export interface InfoItem {
    title: string;
    description: string;
    image: string;
    image1: string;
    image2: string;
    image3: string;
    link: string;
}

type HomeInfoProps = {
    items: InfoItem[];
};

export const HomeInfo: React.FC<HomeInfoProps> = ({ items }) => (
    <div className={classes.homeInfo}>
        {items.map((item) => (
            <div key={item.title} className={classes.infoBlock}>
                <div className={classes.infoBlockContent}>
                    <div>
                        <SafeHtml
                            as="h1"
                            className={classes.infoBlockTitle}
                            html={withBrandHighlight(item.title, classes.brandHighlight)}
                        />
                        <SafeHtml as="p" className={classes.infoBlockDescription} html={item.description} />
                        <ShopNowButton link={item.link} />
                    </div>
                </div>
                <div className={classes.infoBlockImagesContainer}>
                    <div className={classes.infoBlockImages}>
                        <div className={classes.image}>
                            <LazyImg src={item.image} alt="image 1" />
                        </div>
                        <div className={classes.image1}>
                            <LazyImg src={item.image1} alt="image 2" />
                        </div>
                        <div className={classes.image2}>
                            <LazyImg src={item.image2} alt="image 3" />
                        </div>
                        <div className={classes.image3}>
                            <LazyImg src={item.image3} alt="image 4" />
                        </div>
                    </div>
                    <div className={classes.wweLogoMobile}>
                        <img src={require('../../svg/wwe-logo-mobile.svg')} alt="wwe logo" />
                    </div>
                </div>
            </div>
        ))}
        <div className={classes.wweLogoDesktop}>
            <img src={require('../../svg/wwe-logo.svg')} alt="wwe logo" />
        </div>
    </div>
);
